// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zuXO","index":"styles_index__472wK"};